<footer class="site-footer">
  <div class="footer-container site-footer__cta">
    <div class="site-footer__pitch">
      <h2 class="site-footer__title">There's more potential<br />in your backyard.</h2>
      <p class="site-footer__text">
        See what a Kore ADU could add to your property — fast, easy, and stress-free.
      </p>
    </div>

    <form class="foot-address" (submit)="$event.preventDefault(); goToPropertyIntake()">
      <span class="foot-address__field">
        <i class="pi pi-map-marker" aria-hidden="true"></i>
        <input class="foot-address__input" type="text" placeholder="Enter your address"
          aria-label="Enter your address" />
      </span>
      <button type="submit" class="foot-address__submit">See What's Possible</button>
    </form>
  </div>

  <div class="footer-container site-footer__bottom">
    <nav class="site-footer__nav" aria-label="Footer">
      @for (item of navItems; track item.href) {
      <a class="site-footer__link" [href]="item.href">{{ item.label }}</a>
      }
    </nav>
    <div class="site-footer__meta">
      <span class="site-footer__copy">© {{ year }} Kore Robotica Construction, Inc.</span>
      <div class="site-footer__legal">
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Use</a>
      </div>
    </div>
  </div>
</footer>
